import { render } from "./CoveoAILoggedIn.vue?vue&type=template&id=561ca5f6"
import script from "./CoveoAILoggedIn.vue?vue&type=script&lang=js"
export * from "./CoveoAILoggedIn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../dow-corp/ui.frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__